import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Root from "./routes/root/root";
import ErrorPage from "./errorPage";
import Apps, {loader as appsLoader} from "./routes/apps/apps";
import { loader as appLoader } from "./routes/app/appLoader";
import Jobs, {loader as jobsLoader} from "./routes/jobs/jobs";
import Job, {loader as jobLoader} from "./routes/job/job";
import DiffEntry, {loader as diffEntryLoader} from "./routes/diffEntry/diffEntry";
import RootFallbackOutlet from "./routes/root/rootFallbackOutlet";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                path: "apps",
                handle: {
                    breadcrumb: (match) => ({ label: "Apps", pathname: match.pathname })
                },
                children: [
                    {
                        index: true,
                        element: <Apps />,
                        loader: appsLoader,
                    },
                    {
                        path: ":appId",
                        loader: appLoader,
                        handle: {
                            breadcrumb: (match) => ({ label: match.data.name, pathname: `${match.pathname}/jobs` }),
                        },
                        shouldRevalidate: ({ currentParams, nextParams}) => currentParams.appId !== nextParams.appId,
                        children: [
                            {
                                path: "jobs",
                                handle: {
                                    breadcrumb: (match) => ({ label: "Jobs", pathname: match.pathname }),
                                },
                                shouldRevalidate: ({ currentParams, nextParams}) => currentParams.appId !== nextParams.appId,
                                children: [
                                    {
                                        index: true,
                                        element: <Jobs/>,
                                        loader: jobsLoader,
                                    },
                                    {
                                        path: ":jobId",
                                        element: <Job/>,
                                        loader: jobLoader,
                                        children: [
                                            {
                                                path: ":diffEntryId",
                                                element: <DiffEntry/>,
                                                loader: diffEntryLoader,
                                            }
                                        ],
                                        handle: {
                                            breadcrumb: (match) => ({ label: match.params.jobId, pathname: match.pathname }),
                                        }
                                    },
                                ]
                            }, 
                        ]
                    },
                ]
            },
            {
                path: "/",
                element: <RootFallbackOutlet />
            },
        ]
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);
